// @flow
import React from 'react'

import IconWarningError from '../../icons/IconWarningError'

type PropsT = {
  leadText?: string,
  text: string,
  actionItem?: React$Element<any>
}

const ErrorPage = ({ leadText, text, actionItem }: PropsT) => (
  <section className='ErrorPage'>
    <div className='expanded row'>
      <div className='small-12 columns'>
        <div className='Error__icon'>
          <IconWarningError />
        </div>
        <p><strong>{leadText}</strong> {text}</p>
        {actionItem}
      </div>
    </div>
  </section>
)

export default ErrorPage
